// Pure helpers over a permission map as returned by GET /users/me/rbac:
// { RESOURCE: { read, write, delete, export } }. Only a literal `true` grants.
const ACTIONS = ["read", "write", "delete", "export"];

export const can = (map, resource, action) => {
  if (!map || typeof map !== "object" || typeof resource !== "string") return false;
  if (typeof action !== "string") return false;
  const normalized = action.toLowerCase();
  if (!ACTIONS.includes(normalized)) return false;
  if (!Object.prototype.hasOwnProperty.call(map, resource)) return false;
  const entry = map[resource];
  if (!entry || typeof entry !== "object") return false;
  return entry[normalized] === true;
};

export const canAny = (map, resource, actions) =>
  Array.isArray(actions) && actions.some((action) => can(map, resource, action));
